import React, { useEffect, useRef } from 'react';
import PushSubscribeButton from '../pushSubscribeButton/PushSubscribeButton.jsx';
import './jgAlertsActivation.css';

const copyByContext = {
  localops: {
    eyebrow: 'JG LocalOps',
    title: 'Enable LocalOps alerts',
    body: 'Get notified about nearby tasks and important updates, even when Joe Galaxy is closed.',
    smallLine: 'This also enables important JG alerts on this device.',
  },
  connect: {
    eyebrow: 'Joe Galaxy',
    title: 'Turn on JG alerts',
    body: 'Get notified about messages, requests, LocalOps tasks, and important updates.',
    smallLine: 'You can turn this off anytime.',
  },
};

const getCopy = (context) => copyByContext[context] || copyByContext.connect;

const JGAlertsActivationSheet = ({
  context = 'connect',
  jwt,
  onClose,
  onStateChange,
  onSubscribed,
  open,
  status = {},
  vapidKey,
  manageInitiallyOpen = false,
}) => {
  const panel = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    if (!open) return undefined;
    const previous = document.activeElement;
    panel.current?.querySelector('button')?.focus();
    return () => previous?.focus?.();
  }, [open]);
  if (!open) return null;

  const copy = getCopy(context);
  return (
    <div className="jgAlertsSheetBackdrop" role="presentation">
      <div
        ref={panel}
        onKeyDown={(event) => {
          // A nested install sheet owns its own interaction.
          if (event.target.closest('[role="dialog"]') !== panel.current) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            close.current?.();
          }
          if (event.key === 'Tab') {
            const buttons = Array.from(
              panel.current.querySelectorAll(
                'button:not(:disabled), a[href], [tabindex="0"]',
              ),
            );
            const first = buttons[0],
              last = buttons[buttons.length - 1];
            if (event.shiftKey && event.target === first) {
              event.preventDefault();
              last?.focus();
            } else if (!event.shiftKey && event.target === last) {
              event.preventDefault();
              first?.focus();
            }
          }
        }}
        aria-labelledby="jg-alerts-title"
        aria-modal="true"
        className="jgAlertsSheet"
        role="dialog"
      >
        <button
          aria-label="Close alerts help"
          className="jgAlertsSheetClose"
          onClick={onClose}
          type="button"
        >
          x
        </button>
        <div className="jgAlertsSheetEyebrow">{copy.eyebrow}</div>
        <h2 id="jg-alerts-title">
          {status.subscribed ? 'Manage alerts' : copy.title}
        </h2>
        <PushSubscribeButton
          className="jgAlertsSubscribe"
          copy={{ helpText: copy.body }}
          jwt={jwt}
          onStateChange={onStateChange}
          onSubscribed={onSubscribed}
          product={context === 'localops' ? 'localops' : 'connect'}
          vapidKey={vapidKey}
          manageInitiallyOpen={manageInitiallyOpen}
        />
        <button className="jgAlertsSecondary" onClick={onClose} type="button">
          Not now
        </button>
      </div>
    </div>
  );
};

export default JGAlertsActivationSheet;
